module.exports = __webpack_public_path__ + "img/live-broadcast-symbol.72a2ed28.svg";